// API Client Configuration - Hardcoded for production
const BASE_URL = 'https://seo-audit-app.cmsdossier.workers.dev';

export const api = {
  async get(endpoint: string) {
    return fetch(`${BASE_URL}${endpoint}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'omit',
    });
  },
  
  async post(endpoint: string, body?: any) {
    return fetch(`${BASE_URL}${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'omit',
      body: body ? JSON.stringify(body) : undefined,
    });
  },
  
  async delete(endpoint: string) {
    return fetch(`${BASE_URL}${endpoint}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'omit',
    });
  },
};
